"use client"

import { useEffect } from "react"
import { useRouter } from "next/navigation"
import { useCurrentUser } from "@/lib/queries/users"
import { getDefaultRouteForUser } from "@/lib/utils/user-helpers"
import { Skeleton } from "@/components/ui/skeleton"

export default function RootPage() {
    const router = useRouter()
    const { data: user, isLoading, error } = useCurrentUser()

    useEffect(() => {
        // Wait for user data to load
        if (isLoading) {
            return
        }

        // If there's an auth error or no user, redirect to login
        if (error || !user) {
            router.push("/login")
            return
        }

        // If user is authenticated, redirect to their default route based on roles
        const defaultRoute = getDefaultRouteForUser(user)
        router.push(defaultRoute)
    }, [user, isLoading, error, router])

    // Show loading state while checking authentication
    // Show loading state while checking authentication
    return (
        <div className="flex h-screen w-full overflow-hidden bg-background">
            {/* Sidebar Skeleton */}
            <div className="hidden md:flex w-64 flex-col border-r bg-sidebar">
                <div className="p-4 border-b h-14 flex items-center">
                    <Skeleton className="h-6 w-32" />
                </div>
                <div className="flex-1 p-4 space-y-4">
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-3/4" />
                    <Skeleton className="h-4 w-5/6" />
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-2/3" />
                </div>
            </div>
            {/* Main Content Skeleton */}
            <div className="flex-1 flex flex-col">
                <div className="h-14 border-b flex items-center px-4 justify-between">
                    <Skeleton className="h-4 w-48" />
                    <Skeleton className="h-8 w-8 rounded-full" />
                </div>
                <div className="flex-1 p-6 space-y-6">
                    <div className="grid gap-4 md:grid-cols-3">
                        <Skeleton className="h-32 rounded-xl" />
                        <Skeleton className="h-32 rounded-xl" />
                        <Skeleton className="h-32 rounded-xl" />
                    </div>
                    <Skeleton className="h-[400px] rounded-xl" />
                </div>
            </div>
        </div>
    )
}

